import { timer, from, pipe } from "rxjs";
import { debounce } from "rxjs/operators";
import { PackagingData, RecycabilityCalculation, RelationData } from "./generated/types";

export const supportedLanguages = ['en', 'de', 'es', 'fr', 'sk'] as const;
export const proposedLanguages = ['en', 'de', 'fr', 'sk'];

export function setBrowserLang(value: string) {
  localStorage.setItem('lang', value);
}

export function getBrowserLang() {

  const langFromLocalStorage = localStorage.getItem('lang');
  if (langFromLocalStorage != null) {
    return langFromLocalStorage;
  }

  const browserLang = navigator.language.split('-')[0];

  return (supportedLanguages as ReadonlyArray<string>).includes(browserLang) ? browserLang : 'en';
}

export function saveJson(filename: string, obj: any) {
  var str = JSON.stringify(obj, null, 2);
  var data = encode(str);

  var blob = new Blob([data], {
    type: 'application/octet-stream'
  });

  var url = URL.createObjectURL(blob);
  var link = document.createElement('a');
  link.setAttribute('href', url);
  link.setAttribute('download', filename);
  var event = document.createEvent('MouseEvents');
  event.initMouseEvent('click', true, true, window, 1, 0, 0, 0, 0, false, false, false, false, 0, null);
  link.dispatchEvent(event);
}


function encode(s: string) {
  var out = [];
  for (var i = 0; i < s.length; i++) {
    out[i] = s.charCodeAt(i);
  }
  return new Uint8Array(out);
}


/**
  * Erlaubt dem Benutzer einen Blob anzusehen oder zu speichern.
  * @param blob Der Blob.
  * @param filename Der Dateiname.
  */
export function saveOrOpenBlob(blob: Blob, filename: string) {
  if ((navigator as any).msSaveOrOpenBlob) {
    (navigator as any).msSaveOrOpenBlob(blob, filename);
  } else {
    const url = URL.createObjectURL(blob);
    downloadURL(url, filename);
  }
}

export function downloadURL(url: string, filename: string) {
  const a = document.createElement('a') as HTMLAnchorElement;
  a.style.display = 'none';
  a.href = url;
  a.setAttribute('download', filename);
  document.body.appendChild(a);
  if (document.createEvent) {
    var event = document.createEvent("MouseEvents");
    event.initMouseEvent(
      "click", true, false, window, 0, 0, 0, 0, 0
      , false, false, false, false, 0, null
    );
    a.dispatchEvent(event);
  } else {
    a.click();
  }
  document.body.removeChild(a);
}


export const isRelatedTo = (fromId: string, toId: string) => (relation: RelationData) => (relation.fromId === fromId && relation.toId === toId) || (relation.fromId === toId && relation.toId === fromId);

export function isIndirectRelatedTo(report: PackagingData, fromId: string, toId: string) {

  let result = false;

  let visited : string[] = [];

  function search(currentId: string, depth: number) {

    if (visited.includes(currentId)) {
      return;
    }

    visited.push(currentId);

    if (currentId === toId && depth > 1) {
      result = true;
      return;
    }

    for (let related of report.parts) {
      var relations = report.relations.filter(isRelatedTo(currentId, related.id));
      if (relations.length > 0) {
        search(related.id, depth + 1);
      }
    }
  }

  search(fromId, 0);

  return result;
}

export function selectiveDebounceTime<T, V>(selector: (value: T) => V, dueTime: number) {
  let prevValue: V = undefined;
  return debounce((value: T) => {
    let nextValue = selector(value);
    if (nextValue !== prevValue) {
      prevValue = nextValue;
      return timer(dueTime);
    } else {
      return from([0]);
    }
  });
}

export function shouldBeNever(value: never) {
  throw new Error(`Invalid execution path with value "${value}".`);
}

export function isAT(calculation: RecycabilityCalculation) {
  return calculation === RecycabilityCalculation.AT2022;
}

export function isFR(calculation: RecycabilityCalculation) {
  return calculation === RecycabilityCalculation.FR2022;
}
